// extracted by mini-css-extract-plugin
export default {"noticeDiv":"AdmissionListNotices_noticeDiv__bDDsZ","noticeHeading":"AdmissionListNotices_noticeHeading__mKaBh"};